/* eslint-disable react/jsx-props-no-spreading */
import React, { useContext, useState } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';

import useTargetContext from '../context/useTargetContext';

export default function JusticationModal() {
  const {
    justificationModal,
    setJustificationModal,
    justificationForm,
    setJustificationForm,
    handleUpdateAll,
    justificationDefaultForm,
    targetUpdate,
  } = useContext(useTargetContext);
  const [disabledJustification, setDisabledJustification] = useState(false);
  const handleCancel = () => {
    setJustificationModal(false);
    setDisabledJustification(false);
    setJustificationForm(justificationDefaultForm);
  };

  const handleFieldChange = (e, newValue) => {
    if (e.target.name === 'is_copy_reason') {
      const copyValue = newValue === true ? 1 : 0;
      setDisabledJustification(newValue);
      setJustificationForm({ ...justificationForm, is_copy_reason: copyValue, justification: '' });
    }

    if (e.target.name === 'justification') {
      setJustificationForm({ ...justificationForm, justification: e.target.value });
    }
  };

  return (
    <Dialog open={justificationModal} onClose={handleCancel} maxWidth='sm' fullWidth>
      <DialogTitle>Notification</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2} mb={1}>
          <Grid xs={12}>
            Please indicate the justification for the
            {targetUpdate?.status === 1 ? ' approval' : ' rejection'} of the request(s)
          </Grid>
          <Box sx={{ padding: '10px' }}>
            <Grid xs={12} pt={2}>
              <FormControlLabel
                control={<Checkbox />}
                sx={{ color: 'red' }}
                id='is_copy_reason'
                name='is_copy_reason'
                label='Tick this if you want to copy the reason provided by the MedRep for this request'
                onChange={(e, newValue) => handleFieldChange(e, newValue)}
              />
            </Grid>
            <Grid xs={12} pt={2}>
              <TextField
                fullWidth
                id='justification'
                name='justification'
                label='Justification'
                onChange={(e, newValue) => handleFieldChange(e, newValue)}
                mt={1}
                value={justificationForm?.justification ?? ''}
                disabled={disabledJustification}
              />
            </Grid>
          </Box>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() =>
            handleUpdateAll(targetUpdate?.row, targetUpdate?.status, targetUpdate?.isall)
          }
        >
          Submit
        </Button>
        <Button onClick={handleCancel}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
}
